import request from "../Requests/requests";
// import { addTag } from "../store/tagsReducer";
import { getTags } from "../asyncActions/getTag";
// import { getTagsList } from "../DropDownMenu/SelectTags/actions/getTagsList";

export const addTags = (payload) => {
    return async dispatch => {
        try {
            const response = await request.post('/Tag/', { userId: localStorage.getItem('userID'), 
            tagName: payload.tagName})
            // .then(() => dispatch(getTagsList()))
            .then(() => dispatch(getTags()))
            // .then(() => dispatch(addTag(payload)))
            const data = response.data
            return data
        } catch (error) {
            return error
        }
    } 
}